export const CACHE_TYPE = Object.freeze({ PEOPLE_IN_STEPS_ANALYTICS: 'stepsSessionsAnalytics' });
